export const tipoLogradouros = [
    { label: 'Rua', value: 'Rua' },
    { label: 'Avenida', value: 'Ave' },
    { label: 'Travessa', value: 'Tra' },
    { label: 'Alameda', value: 'Ala' },
    { label: 'Praça', value: 'Pra' },
    { label: 'Estrada', value: 'Est' }
  ];
  